<template>
  <Button
    :label="$t('Download order summary')"
    @click="downloadOrderSummary"
  />
</template>

<script setup lang="ts">
import Button from '@/components/input-components/Button.vue'
import { useOrdersStore } from '@/stores/orders'
import { usePhysiciansStore } from '@/stores/physicians'
import { useI18n } from 'vue-i18n'

const ordersStore = useOrdersStore()
const physiciansStore = usePhysiciansStore()
const { t, locale } = useI18n()

async function downloadOrderSummary(): Promise<void> {
  const payload = {
    orderId: ordersStore.getOrder.orderId,
    doctorId: physiciansStore.getPhysician?.userId,
    languageId: locale.value,
  }

  await ordersStore.fetchOrderSummary(payload)
}
</script>
